import { Service, signal } from '@angular/core';

// Shared between app-main-footer (the toggle control) and app-root (which
// owns the layout grid that actually shows/hides app-main-nav). Toggling
// hides the sidebar entirely rather than shrinking it to cw-navigation-drawer's
// own icon-only rail — main-nav no longer sets its `collapsible` input, so
// this is the only collapse mechanism in play.
@Service()
export class SidebarNavigationState {
  readonly visible = signal(true);

  toggle(): void {
    this.visible.update((value) => !value);
  }
}
